import parseLocaleMoney from '../utils/parseLocaleMoney';

export default function clampPriceInput(input) {
  const value = (input.value || '').trim();
  if (value === '') return;

  const cents = parseLocaleMoney(value);
  if (cents == null) return;

  const minRaw = parseLocaleMoney(input.dataset.min);
  const maxRaw = parseLocaleMoney(input.dataset.max);
  const min = minRaw == null ? 0 : minRaw;

  let clamped = cents;
  if (clamped < min) clamped = min;
  if (maxRaw != null && clamped > maxRaw) clamped = maxRaw;

  if (clamped !== cents && window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    input.value = window.Shopify.formatMoney(clamped, input.dataset.moneyFormat);
  }
}
